// Function to force delete a user with extreme measures
export const forceDeleteUser = async (email: string) => {
  try {
    console.log(`Attempting to force delete user: ${email}`);
    
    const response = await fetch(`${import.meta.env.VITE_SUPABASE_URL}/functions/v1/force-delete-user`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${import.meta.env.VITE_SUPABASE_ANON_KEY}`
      },
      body: JSON.stringify({ email })
    });
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to force delete user');
    }
    
    const result = await response.json();
    
    if (result.success) {
      console.log('Force delete operation successful');
      return { success: true, message: 'User account force deleted successfully' };
    } else {
      throw new Error(result.error || 'Force delete operation failed');
    }
    
  } catch (error) {
    console.error('Error in force delete:', error);
    return {
      success: false,
      error: error instanceof Error ? error.message : '既存のアカウントの削除に失敗しました'
    };
  }
};